const Header = () => {
  return (
    <div>
      <h1 className="heading_">TIP CALCULATOR</h1>
    </div>
  );
};

export default Header;
